import script from "./NbsLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./NbsLogo.vue?vue&type=script&setup=true&lang=js"

import "./NbsLogo.vue?vue&type=style&index=0&id=73a70164&lang=scss"

const __exports__ = script;

export default __exports__